
var Model = require("./types/Model.js");

module.exports = Model({
	name: "fileviewer",
	init: init,
	triggers: triggers,
});

function init() {
	this.push({
		file: null
	});
}

function triggers() {
	return {
		"view": view,
		"close": close
	};
}

var LIST = [
	"image",
	"video",
	"pdf",
	"audio"
];

function view(data) {
	var file = data.file;
	var format = data.file.format;
	var regex = new RegExp("(" + LIST.join("|") + ")");
	this.emit("usermetrics:trigger:track", "view file in fullscreen", {
		type: format,
	});
	if(!regex.test(format)){
		this.emit("linkopener:trigger:open", {
			uri: file.url
		});
		return;
	} else {
		this.extend({
			file: file
		});
	}
}

function close(){
	this.extend({
		file: null
	});
	this.emit("usermetrics:trigger:track", "close fullscreen file viewer");
}
